import React from 'react';
import { useNavigate } from 'react-router-dom';

function TopNavBar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear session data
    sessionStorage.removeItem('studentSession');
    // Redirect to login page
    navigate('/login');
  };

  return (
    <>
      <div className="top-navbar flex-between gap-16">
        <div className="flex-align gap-16">
          {/* Toggle Button Start */}
          <button
            type="button"
            className="toggle-btn d-xl-none d-flex text-26 text-gray-500"
          >
            <i className="ph ph-list" />
          </button>
          {/* Toggle Button End */}
          {/* <form action="#" class="w-350 d-sm-block d-none">
            <div class="position-relative">
                <button type="submit" class="input-icon text-xl d-flex text-gray-100 pointer-event-none"><i class="ph ph-magnifying-glass"></i></button>
                <input type="text" class="form-control ps-40 h-40 border-transparent focus-border-main-600 bg-main-50 rounded-pill placeholder-15" placeholder="Search...">
            </div>
          </form> */}
        </div>
        <div className="flex-align gap-16">
          <div className="flex-align gap-8"></div>
          {/* User Profile Start */}
          {/* <div className="dropdown">
            <button
              className="users arrow-down-icon border border-gray-200 rounded-pill p-4 d-inline-block pe-40 position-relative"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="position-relative">
                <img
                  src="/assets/images/logo/smmlogo.png"
                  alt="Image"
                  className="h-32 w-32 rounded-circle"
                />
                <span className="activation-badge w-8 h-8 position-absolute inset-block-end-0 inset-inline-end-0" />
              </span>
            </button>
       
       
          </div> */}
          {/* User Profile End */}
        </div>
      </div>
    </>
  );
}

export default TopNavBar;